import React, {useState} from "react";
import {Button, Grid2 as Grid} from "@mui/material";
import {pushAnalytics} from "../helpers";
import SsoDialog from "./SsoDialog";
import {KeycloakAuth} from "./KeycloakAuth";
import {AUTHORIZED_STATE_DONE, AUTHORIZED_STATE_NO_ORG_ID} from "../constants";
import PeopleIcon from '@mui/icons-material/People';
import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";


export function AuthorizeButtonsContainer({
                                              allowManualInput,
                                              federationId,
                                              defaultOrgId,
                                              setAuthorized
                                          }) {
    const {t} = useTranslation();

    const [ssoDialog, setSsoDialog] = useState({
        open: false
    });

    const handleIAmToken = (iAmToken) => {
        localStorage.setItem("iAmToken", iAmToken);

        if (!allowManualInput && defaultOrgId !== "") {
            setAuthorized(AUTHORIZED_STATE_DONE);
        } else {
            setAuthorized(AUTHORIZED_STATE_NO_ORG_ID);
        }

        setSsoDialog(prev => ({
            ...prev,
            open: false
        }));
    };

    const handleKeycloakAuthSuccess = (token) => {
        // Keycloak token is automatically used in requests
        if (!allowManualInput && defaultOrgId !== "") {
            setAuthorized(AUTHORIZED_STATE_DONE);
        } else {
            setAuthorized(AUTHORIZED_STATE_NO_ORG_ID);
        }
    };

    const handleKeycloakAuthError = (error) => {
        console.error('Keycloak authentication error:', error);
    };

    return <Grid container spacing={2} direction="column"
                 alignItems="center" alignContent="center" justifyContent="center">
        <SsoDialog
            state={ssoDialog.open}
            handleClose={() => setSsoDialog(prev => ({...prev, open: false}))}
            handleIAmToken={handleIAmToken}
            federationId={federationId}
            allowManualInput={allowManualInput}
        />

        {/* Keycloak Auth Button */}
        <KeycloakAuth 
            onAuthSuccess={handleKeycloakAuthSuccess}
            onAuthError={handleKeycloakAuthError}
        />

        <Grid size={{xs: 12, sm: 8, md: 4, lg: 3, xl: 2}}>
            <Button size="large" fullWidth sx={{height: 65, borderRadius: 7, textTransform: 'none'}} variant="contained"
                    startIcon={<PeopleIcon/>} onClick={() => {
                setSsoDialog(prev => ({...prev, open: true}));
                pushAnalytics('ssoButtonClick');
            }}>
                <Typography fontSize="1.2rem">
                    {t('components:authorize_buttons_container.sso')}
                </Typography>
            </Button>
        </Grid>
    </Grid>
}